module.exports = __webpack_public_path__ + "static/media/icn_outside_india_myway.9a90154b.svg";